// D:\repository\mob-on-batatais-eletromobilidade\src\App.js

import React from "react";
import "./App.css"; // mantenha se tiver estilos globais
import MobOn from "./components/Mob-On/mob-on";

import { FaWhatsapp } from "react-icons/fa";

function App() {
  return (
    <div className="App">
      <MobOn />

      <a
        href={`https://wa.me/5516991458575?text=${encodeURIComponent(
          "Olá! Acabei de visitar o site da Mob-On e gostaria de mais informações."
        )}`}
        className="whatsapp-fixed"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp Flutuante"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
}

export default App;
